export default {
  common: {
    welcome: 'Bienvenue',
    loading: 'Chargement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    search: 'Rechercher...',
    filter: 'Filtrer',
    export: 'Exporter',
    refresh: 'Actualiser',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    confirm: 'Confirmer',
    yes: 'Oui',
    no: 'Non',
    close: 'Fermer',
    actions: 'Actions',
    status: 'Statut',
    active: 'Actif',
    inactive: 'Inactif',
    enabled: 'Activé',
    disabled: 'Désactivé',
    success: 'Succès',
    error: 'Erreur',
    warning: 'Avertissement',
    info: 'Info',
    apply: 'Appliquer',
    download: 'Télécharger',
    upload: 'Importer',
    view: 'Voir',
    details: 'Détails',
    name: 'Nom',
    email: 'E-mail',
    phone: 'Téléphone',
    address: 'Adresse',
    country: 'Pays',
    city: 'Ville',
    state: 'État',
    zipCode: 'Code postal',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    description: 'Description',
    type: 'Type',
    amount: 'Montant',
    date: 'Date',
    time: 'Heure',
    from: 'De',
    to: 'À',
    all: 'Tous',
    none: 'Aucun',
    select: 'Sélectionner',
    selected: 'Sélectionné',
    total: 'Total',
    subtotal: 'Sous-total',
    pending: 'En attente',
    approved: 'Approuvé',
    rejected: 'Rejeté',
    completed: 'Terminé',
    failed: 'Échoué',
    processing: 'En cours',
    cancelled: 'Annulé',
    required: 'Obligatoire',
    optional: 'Optionnel',
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    thisWeek: 'Cette semaine',
    thisMonth: 'Ce mois',
    lastMonth: 'Mois dernier',
    custom: 'Personnalisé',
    range: 'Plage',
    noData: 'Aucune donnée disponible',
    noResults: 'Aucun résultat',
    showMore: 'Afficher plus',
    showLess: 'Afficher moins',
    expand: 'Développer',
    collapse: 'Réduire',
    clearAll: 'Tout effacer',
    selectAll: 'Tout sélectionner',
    deselectAll: 'Tout désélectionner',
    copyToClipboard: 'Copier dans le presse-papiers',
    copied: 'Copié !',
    notAvailable: 'N/D',
    upgrade: 'Mettre à niveau',
  },
  auth: {
    login: 'Connexion',
    logout: 'Déconnexion',
    email: 'E-mail',
    password: 'Mot de passe',
    rememberMe: 'Se souvenir de moi',
    forgotPassword: 'Mot de passe oublié ?',
    signIn: 'Se connecter',
    signUp: 'S\'inscrire',
    loginSuccess: 'Connexion réussie',
    loginError: 'E-mail ou mot de passe invalide',
    sessionExpired: 'Session expirée. Veuillez vous reconnecter.',
    adminPanel: 'Panneau d\'administration',
    needHelp: 'Besoin d\'aide ?',
    poweredBy: 'Propulsé par',
  },
  nav: {
    dashboard: 'Tableau de bord',
    instruments: 'Instruments',
    clients: 'Clients',
    accounts: 'Comptes',
    trading: 'Trading',
    reports: 'Rapports',
    auditLog: 'Journal d\'audit',
    withdrawals: 'Retraits',
    deposits: 'Dépôts',
    settings: 'Paramètres',
    plugins: 'Plugins',
    accountGroups: 'Groupes de comptes',
    kyc: 'KYC',
    apiDocs: 'Docs API',
    notifications: 'Notifications',
    upgrade: 'Mettre à niveau',
    groupPricing: 'Tarification groupe',
  },
  dashboard: {
    title: 'Tableau de bord',
    overview: 'Aperçu',
    stats: 'Statistiques',
    totalClients: 'Total clients',
    totalAccounts: 'Total comptes',
    openPositions: 'Positions ouvertes',
    todayPnL: 'P&L du jour',
    liveAccounts: 'Comptes réels',
    demoAccounts: 'Comptes démo',
    activeClients: 'Clients actifs',
    activeTraders: 'Traders actifs',
    newClients: 'Nouveaux clients',
    volumeChart: 'Volume de trading (7 jours)',
    pnlTrend: 'Tendance P&L (30 jours)',
    recentActivity: 'Activité récente',
    quickActions: 'Actions rapides',
    financialOverview: 'Aperçu financier',
    financialOverview30Days: 'Aperçu financier (30 jours)',
    riskAlerts: 'Alertes de risque',
    riskDistribution: 'Distribution des risques',
    currentPlan: 'Plan actuel',
    planUsage: 'Utilisation du plan',
    allowedMarkets: 'Marchés autorisés',
    accountOverview: 'Aperçu des comptes',
    activeUsers: 'Utilisateurs actifs',
    activeThisMonth: 'Actifs ce mois',
    plan: 'plan',
    feedLatency: 'Latence du flux',
    expires: 'Expire',
    cashFlowComparison: 'Comparaison des flux',
    totalTransactions: 'total transactions',
    totalDeposits: 'total dépôts',
    totalWithdrawals: 'total retraits',
  },
  instruments: {
    title: 'Gestion des instruments',
    library: 'Bibliothèque d\'instruments',
    enabled: 'Instruments activés',
    feed: 'Instruments du flux',
    symbol: 'Symbole',
    category: 'Catégorie',
    priceScale: 'Échelle de prix',
    leverage: 'Levier',
    spread: 'Spread',
    commission: 'Commission',
    enable: 'Activer',
    disable: 'Désactiver',
    bulkEnable: 'Activation groupée',
    settings: 'Paramètres',
    tradeMode: 'Mode de trading',
    executionType: 'Type d\'exécution',
    forex: 'Forex',
    crypto: 'Crypto',
    stocks: 'Actions',
    indices: 'Indices',
    commodities: 'Matières premières',
    general: 'Général',
    leverageLots: 'Levier et lots',
    spreads: 'Spreads',
    commissions: 'Commissions',
    riskManagement: 'Gestion des risques',
    advanced: 'Avancé',
    maxLeverage: 'Levier maximum',
    minLotSize: 'Taille de lot minimale',
    maxLotSize: 'Taille de lot maximale',
    lotStep: 'Pas de lot',
    spreadType: 'Type de spread',
    spreadMarkup: 'Majoration du spread',
    fixedSpread: 'Spread fixe',
    commissionPerLot: 'Commission par lot',
    commissionType: 'Type de commission',
    stopLevel: 'Niveau de stop',
    freezeLevel: 'Niveau de gel',
    maxPositions: 'Positions maximales',
    enableSuccess: 'Instrument activé avec succès',
    disableSuccess: 'Instrument désactivé avec succès',
    updateSuccess: 'Paramètres mis à jour avec succès',
    bulkEnableSuccess: 'Instruments activés avec succès',
  },
  clients: {
    title: 'Clients',
    clientsList: 'Liste des clients',
    clientDetails: 'Détails du client',
    name: 'Nom',
    email: 'E-mail',
    phone: 'Téléphone',
    country: 'Pays',
    kycStatus: 'Statut KYC',
    accountCount: 'Comptes',
    totalBalance: 'Solde total',
    lastLogin: 'Dernière connexion',
    createdAt: 'Créé le',
    verified: 'Vérifié',
    pending: 'En attente',
    rejected: 'Rejeté',
    searchPlaceholder: 'Rechercher des clients...',
    nameOrEmail: 'Nom ou e-mail...',
    editClient: 'Modifier le client',
    configureOverride: 'Configurer le remplacement utilisateur',
    noClientsFound: 'Aucun client trouvé',
  },
  accounts: {
    title: 'Comptes',
    accountsList: 'Liste des comptes',
    accountDetails: 'Détails du compte',
    accountNumber: 'Numéro de compte',
    accountType: 'Type de compte',
    accountGroup: 'Groupe de compte',
    accountSettings: 'Paramètres du compte',
    accountState: 'État du compte',
    accountActive: 'Compte actif',
    balance: 'Solde',
    equity: 'Équité',
    margin: 'Marge',
    freeMargin: 'Marge libre',
    marginLevel: 'Niveau de marge',
    leverage: 'Levier',
    credit: 'Crédit',
    debit: 'Débit',
    adjustBalance: 'Ajuster le solde',
    changeLeverage: 'Modifier le levier',
    live: 'Réel',
    demo: 'Démo',
    searchPlaceholder: 'Rechercher par numéro ou e-mail...',
    accountNumberOrEmail: 'Numéro de compte ou e-mail...',
    balanceChange: 'Modification du solde',
    reasonForAdjustment: 'Raison de l\'ajustement...',
    accountUpdatedSuccess: 'Compte mis à jour avec succès',
    noAccountsFound: 'Aucun compte trouvé',
  },
  trading: {
    title: 'Trading',
    positions: 'Positions',
    orders: 'Ordres',
    history: 'Historique',
    symbol: 'Symbole',
    side: 'Sens',
    volume: 'Volume',
    openPrice: 'Prix d\'ouverture',
    currentPrice: 'Prix actuel',
    pnl: 'P&L',
    buy: 'Achat',
    sell: 'Vente',
    open: 'Ouvert',
    pending: 'En attente',
    closed: 'Fermé',
    closedAt: 'Fermé le',
    openedAt: 'Ouvert le',
    price: 'Prix',
    totalTrades: 'Total trades',
    winningTrades: 'Trades gagnants',
    losingTrades: 'Trades perdants',
    totalPnL: 'P&L total',
    account: 'Compte',
    status: 'Statut',
    swap: 'Swap',
    commission: 'Commission',
    ticket: 'Ticket',
    noPositions: 'Aucune position ouverte',
    noOrders: 'Aucun ordre en attente',
    noHistory: 'Aucun historique de trading',
    bid: 'Bid',
    ask: 'Ask',
    tradingManagement: 'Gestion du trading',
    liveMonitoring: 'Surveillance en direct',
    disconnected: 'Déconnecté',
    activeTraders: 'Traders actifs',
    openPositions: 'Positions ouvertes',
    pendingOrders: 'Ordres en attente',
    floatPnL: 'P&L flottant',
    accountState: 'État du compte',
    marginCall: 'APPEL DE MARGE',
    stopOutRisk: 'RISQUE STOP-OUT',
    live: 'EN DIRECT',
    offline: 'HORS LIGNE',
    snapshot: 'INSTANTANÉ',
    marginLvl: 'Niveau marge',
    openTrades: 'Trades ouverts',
    freeMargin: 'Marge libre',
    marginUsed: 'Marge utilisée',
    balance: 'Solde',
    equity: 'Équité',
    credit: 'Crédit',
    slTp: 'SL / TP',
    fees: 'Frais',
    netPnL: 'P&L net',
    grossPnL: 'P&L brut',
    reason: 'Raison',
    openedClosed: 'Ouvert / Fermé',
    closePrice: 'Prix de clôture',
    reserved: 'Réservé',
    reservedMargin: 'Marge réservée',
    created: 'Créé',
    triggerPrice: 'Prix déclencheur',
    duration: 'Durée',
    closedTrades: 'Trades fermés',
    activeTrades: 'Actif',
    stopLoss: 'Stop Loss',
    takeProfit: 'Take Profit',
    closePosition: 'Fermer la position',
    cancelOrder: 'Annuler l\'ordre',
    modifyPosition: 'Modifier la position',
    thisActionCannotBeUndone: 'Cette action est irréversible',
    enterStopLoss: 'Entrez le prix du stop loss',
    enterTakeProfit: 'Entrez le prix du take profit',
    filterTrading: 'Filtrer le trading',
    traderSymbolAccount: 'Trader, symbole, compte...',
    noFound: 'Aucun {tab} trouvé',
    showingOf: 'Affichage {from}–{to} sur {total} traders',
    traderCount: '{count} trader(s) · {total} {tab}',
    positionClosedSuccess: 'Position fermée avec succès',
    orderCancelledSuccess: 'Ordre annulé avec succès',
    positionModifiedSuccess: 'Position modifiée avec succès',
    failedToClosePosition: 'Échec de la fermeture de position',
    failedToCancelOrder: 'Échec de l\'annulation de l\'ordre',
    failedToModifyPosition: 'Échec de la modification de position',
    invalidPosition: 'Position invalide : ID manquant',
  },
  reports: {
    title: 'Rapports',
    exposure: 'Rapport d\'exposition',
    profitability: 'Rentabilité clients',
    daily: 'Rapport journalier',
    dateRange: 'Plage de dates',
    totalExposure: 'Exposition totale',
    netVolume: 'Volume net',
    topWinners: 'Meilleurs gagnants',
    topLosers: 'Principaux perdants',
    buyVolume: 'Volume achat',
    sellVolume: 'Volume vente',
    positionCount: 'Nombre de positions',
    winRate: 'Taux de réussite',
    rank: 'Rang',
    client: 'Client',
    noData: 'Aucune donnée disponible',
    totalVolume: 'Volume total',
    commission: 'Commission',
    activeAccounts: 'Comptes actifs',
    export: 'Exporter',
    download: 'Télécharger',
    positions: 'Positions',
    trades: 'Trades',
    winning: 'Gagnants',
    losing: 'Perdants',
  },
  settings: {
    title: 'Paramètres',
    brokerInfo: 'Informations du courtier',
    brokerSettings: 'Paramètres du courtier',
    brokerName: 'Nom du courtier',
    brokerNameRequired: 'Nom du courtier *',
    brokerLogo: 'Logo du courtier',
    brokerStatus: 'Statut du courtier',
    domain: 'Domaine',
    primaryColor: 'Couleur principale',
    secondaryColor: 'Couleur secondaire',
    logo: 'Logo',
    supportEmail: 'E-mail support',
    supportPhone: 'Téléphone support',
    generalInfo: 'Informations générales',
    branding: 'Image de marque',
    accountGroups: 'Groupes de comptes',
    addNewGroup: 'Ajouter un groupe',
    createFirstGroup: 'Créer votre premier groupe',
    noGroupsFound: 'Aucun groupe de comptes trouvé',
    default: 'Par défaut',
    maxLeverage: 'Levier maximum',
    marginCall: 'Appel de marge',
    stopOut: 'Stop out',
    commission: 'Commission',
    maxLotSize: 'Taille de lot maximale',
    execution: 'Exécution',
    hedgingAllowed: 'Hedging autorisé',
    scalpingAllowed: 'Scalping autorisé',
    eaTrading: 'Trading EA',
    nbpEnabled: 'NBP activé',
    saving: 'Enregistrement...',
    groupName: 'Nom du groupe',
    description: 'Description',
    editGroup: 'Modifier le groupe',
    deleteGroup: 'Supprimer le groupe',
    cannotDeleteDefault: 'Impossible de supprimer le groupe par défaut',
    confirmDelete: 'Confirmer la suppression de "{name}" ? Cette action est irréversible.',
    groupCreatedSuccess: 'Groupe créé avec succès',
    groupUpdatedSuccess: 'Groupe mis à jour avec succès',
    groupDeletedSuccess: 'Groupe supprimé avec succès',
    failedToSave: 'Échec de l\'enregistrement du groupe',
    failedToDelete: 'Échec de la suppression du groupe',
    failedToLoad: 'Échec du chargement des groupes',
    configureYourBroker: 'Configurez les informations de votre courtier',
    loadingSettings: 'Chargement des paramètres...',
    legalName: 'Raison sociale',
    licenseNumber: 'Numéro de licence',
    environment: 'Environnement',
    contactInformation: 'Coordonnées',
    readOnly: 'Lecture seule',
    readOnlyContactSupport: 'Lecture seule — contactez le support pour modifier',
    supportedLanguages: 'Langues supportées',
    selectLanguagesDescription: 'Sélectionnez les langues disponibles sur le portail client.',
    systemLimits: 'Limites système',
    maxAccounts: 'Comptes maximum',
    maxConcurrentTrades: 'Trades simultanés maximum',
    maintenanceMode: 'Mode maintenance',
    enableMaintenanceMode: 'Activer le mode maintenance',
    maintenanceModeDescription: 'Lorsqu\'activé, les clients voient le message de maintenance',
    maintenanceMessage: 'Message de maintenance',
    maintenanceMessagePlaceholder: 'Nous effectuons une maintenance planifiée. Revenez bientôt.',
    saveChanges: 'Enregistrer les modifications',
    howToConnectDomain: 'Comment connecter votre domaine',
    unlockToEdit: 'Déverrouiller pour modifier le domaine',
    lockDomain: 'Verrouiller le domaine',
    changingDomainWarning: 'Modifier votre domaine peut interrompre l\'accès client. Confirmer ?',
    changingDomainWarningLong: 'Modifier votre domaine peut interrompre l\'accès client et les DNS temporairement. Confirmer ?',
    domainBreakWarning: '⚠️ Modifier le domaine peut interrompre l\'accès client temporairement',
    domainBreakWarningLong: '⚠️ Modifier le domaine peut interrompre l\'accès client et le routage DNS temporairement',
  },
  accountGroups: {
    title: 'Groupes de comptes',
    activeGroups: 'actif',
    defaultGroups: 'défaut',
    addNewGroup: 'Ajouter un groupe',
    createFirstGroup: 'Créer votre premier groupe',
    noGroupsFound: 'Aucun groupe de comptes trouvé',
    groupDetails: 'Détails du groupe',
    pricingOverrides: 'Remplacements de tarification',
    riskSettings: 'Paramètres de risque',
    tradingSettings: 'Paramètres de trading',
  },
  groupPricing: {
    title: 'Remplacements de tarification de groupe',
    infoBanner: 'Remplacements de tarification du groupe de comptes',
    infoDescription: 'Configurez une tarification personnalisée pour les groupes. Laissez vide (NULL) pour utiliser les valeurs par défaut.',
    editPricingOverrides: 'Modifier les remplacements',
    spreadMarkup: 'Majoration du spread',
    spreadMarkupPips: 'Majoration du spread (pips)',
    commission: 'Commission',
    commissionPerLot: 'Commission par lot (USD)',
    maxLeverageOverride: 'Remplacement du levier maximum',
    brokerDefault: 'Défaut courtier',
    useBrokerDefault: 'Utiliser le défaut courtier',
    clearUseBrokerDefault: 'Effacer (utiliser défaut courtier)',
    saveOverrides: 'Enregistrer les remplacements',
    overridesUpdatedSuccess: 'Remplacements mis à jour avec succès',
    failedToUpdate: 'Échec de la mise à jour',
    leaveEmptyInfo: 'Laissez vide pour utiliser les valeurs du courtier.',
    pips: 'pips',
    perLot: '/lot',
  },
  kyc: {
    title: 'Tableau de bord KYC',
    allKyc: 'Tout le KYC',
    allStatus: 'Tous les statuts',
    allKycStatus: 'Tous les statuts KYC',
    pending: 'En attente',
    approved: 'Approuvé',
    rejected: 'Rejeté',
    verified: 'Vérifié',
    actionNeeded: 'Action requise',
    awaitingAction: 'En attente d\'action',
    allCaughtUp: 'Tout est à jour !',
    noApplications: 'Aucune demande KYC en attente.',
    searchPlaceholder: 'Rechercher par nom, e-mail ou ID...',
    nameEmailOrId: 'ID, nom ou e-mail...',
    confirmApproval: 'Confirmer l\'approbation KYC',
    confirmRejection: 'Confirmer le rejet — entrez une raison (obligatoire).',
    rejectionReason: 'Expliquez pourquoi cette demande est rejetée (obligatoire)',
    approveSuccess: 'KYC approuvé avec succès',
    rejectSuccess: 'KYC rejeté avec succès',
    failedToApprove: 'Échec de l\'approbation KYC',
    failedToReject: 'Échec du rejet KYC',
    basicVerified: 'Vérification basique',
    fullVerified: 'Vérification complète',
    allApplications: 'Toutes les demandes',
    kycVerification: 'Vérification KYC',
    reviewManageDesc: 'Examinez et gérez les demandes de vérification',
    pluginSettings: 'Paramètres du plugin',
    reviewKycApplication: 'Examiner la demande KYC',
    verificationLevel: 'Niveau de vérification',
    personalInformation: 'Informations personnelles',
    fullName: 'Nom complet',
    dateOfBirth: 'Date de naissance',
    nationality: 'Nationalité',
    addressLabel: 'Adresse',
    sourceOfFunds: 'Source des fonds',
    noPersonalData: 'Aucune donnée personnelle soumise',
    uploadedDocuments: 'Documents téléchargés',
    noDocumentsUploaded: 'Aucun document téléchargé',
    yourDecision: 'Votre décision',
    approve: 'Approuver',
    reject: 'Rejeter',
    rejectionReasonLabel: 'Raison du rejet',
    submitting: 'Envoi en cours...',
    submitReview: 'Soumettre la révision',
    previewNotAvailable: 'Aperçu non disponible',
    downloadFile: 'Télécharger le fichier',
    uploaded: 'Téléchargé',
    pendingReview: 'En attente de révision',
    allLevels: 'Tous les niveaux',
    allStatuses: 'Tous les statuts',
    allActions: 'Toutes les actions',
    userCol: 'Utilisateur',
    currentLevel: 'Niveau actuel',
    docsCol: 'Docs',
    lastUpdated: 'Dernière mise à jour',
    levelCol: 'Niveau',
    actionCol: 'Action',
    performedBy: 'Effectué par',
    detailsCol: 'Détails',
    dateTime: 'Date & Heure',
    submittedCol: 'Soumis',
    noApplicationsFound: 'Aucune demande trouvée',
    noAuditRecords: 'Aucun enregistrement d\'audit',
    noMatchingApplications: 'Aucune demande correspondante',
    noPendingApplications: 'Aucune demande en attente',
    systemAuto: 'Système (Auto)',
    admin: 'Admin',
    traderLabel: 'Trader',
    upgradedTo: 'Mis à niveau vers',
    pendingApplications: 'demande en attente',
    pendingApplicationsPlural: 'demandes en attente',
    users: 'utilisateur',
    usersPlural: 'utilisateurs',
    records: 'enregistrement',
    recordsPlural: 'enregistrements',
    applications: 'demande',
    applicationsPlural: 'demandes',
    totalUsers: 'Total utilisateurs',
    basicVerifiedStat: 'Vérification basique',
    moderateVerified: 'Vérification modérée',
    fullyVerified: 'Entièrement vérifié',
    pendingSuffix: '+{count} en attente',
    levelBasic: 'Basique',
    levelModerate: 'Modéré',
    levelVerified: 'Vérifié',
    notStarted: 'Non commencé',
    none: 'Aucun',
    unknown: 'Inconnu',
    review: 'Examiner',
    auditLog: 'Journal d\'audit',
    requiredDocuments: 'Documents requis',
    requiredDocsDesc: 'Sélectionnez les documents requis pour chaque niveau KYC.',
    kycDocuments: 'Documents KYC {level}',
    selected: '{count} sélectionné',
    approvalMode: 'Mode d\'approbation',
    manualReview: 'Révision manuelle',
    autoApprove: 'Approbation automatique',
    autoApproveLevels: 'Niveaux d\'approbation automatique',
    basicKyc: 'KYC basique',
    moderateKyc: 'KYC modéré',
    verifiedKyc: 'KYC vérifié',
    enforceOnDeposit: 'Exiger KYC lors des dépôts',
    enforceOnWithdrawal: 'Exiger KYC lors des retraits',
    basic: 'Basique',
    moderate: 'Modéré',
    verified: 'Vérifié',
    howItWorks: 'Fonctionnement :',
    howItWorksBullet1: 'Montants inférieurs au seuil basique : KYC non requis',
    howItWorksBullet2: 'Montants supérieurs au basique : KYC basique requis',
    howItWorksBullet3: 'Montants supérieurs au modéré : KYC modéré requis',
    howItWorksBullet4: 'Montants supérieurs au vérifié : Vérification complète requise',
    saveConfiguration: 'Enregistrer la configuration',
    savingConfiguration: 'Enregistrement...',
    openKycDashboard: 'Ouvrir le tableau de bord KYC',
    enableToViewStats: 'Activez le plugin pour voir les statistiques',
    statNone: 'Aucun',
    docGovIdFrontLabel: 'Pièce d\'identité officielle (recto)',
    docGovIdFrontDesc: 'Passeport, permis de conduire ou carte d\'identité - recto',
    docGovIdBackLabel: 'Pièce d\'identité officielle (verso)',
    docGovIdBackDesc: 'Verso de la carte d\'identité',
    docSelfieLabel: 'Selfie avec pièce d\'identité',
    docSelfieDesc: 'Photo tenant la pièce d\'identité à côté du visage',
    docProofAddressLabel: 'Justificatif de domicile',
    docProofAddressDesc: 'Facture ou relevé bancaire (< 3 mois)',
    docBankStatementLabel: 'Relevé bancaire',
    docBankStatementDesc: 'Relevé récent avec nom et compte',
    docSourceFundsLabel: 'Source des fonds',
    docSourceFundsDesc: 'Document prouvant l\'origine des fonds',
    docEmploymentLabel: 'Lettre d\'emploi',
    docEmploymentDesc: 'Lettre de confirmation de l\'employeur',
    docTaxIdLabel: 'Document d\'identification fiscale',
    docTaxIdDesc: 'Certificat d\'identification fiscale',
    docOtherLabel: 'Autres documents',
    docOtherDesc: 'Documents justificatifs supplémentaires',
    auditActions: {
      submitted: 'Soumis',
      approved: 'Approuvé',
      rejected: 'Rejeté',
      document_uploaded: 'Doc téléchargé',
      document_approved: 'Doc approuvé',
      document_rejected: 'Doc rejeté',
      level_upgraded: 'Niveau mis à niveau',
      resubmission: 'Nouvelle soumission',
    },
  },
  deposits: {
    title: 'Dépôts',
    allDeposits: 'Tous les dépôts',
    allStatuses: 'Tous les statuts',
    pending: 'En attente',
    approved: 'Approuvé',
    rejected: 'Rejeté',
    completed: 'Terminé',
    searchPlaceholder: 'Rechercher des dépôts...',
    searchByIdNameEmail: 'Rechercher par ID, nom ou e-mail...',
    idNameOrEmail: 'ID, nom ou e-mail...',
    depositProof: 'Preuve de dépôt',
    depositProofPdf: 'PDF preuve de dépôt',
    amount: 'Montant',
    method: 'Méthode',
    status: 'Statut',
    trader: 'Trader',
    date: 'Date',
    actions: 'Actions',
    approve: 'Approuver',
    reject: 'Rejeter',
    confirmApproval: 'Confirmer l\'approbation — cela créditera le solde du trader.',
    confirmRejection: 'Confirmer le rejet — entrez une raison (optionnel).',
    rejectionReason: 'Raison du rejet (optionnel)...',
    approveSuccess: 'Dépôt approuvé avec succès',
    rejectSuccess: 'Dépôt rejeté avec succès',
    failedToApprove: 'Échec de l\'approbation du dépôt',
    failedToReject: 'Échec du rejet du dépôt',
    noDepositsFound: 'Aucun dépôt trouvé',
    proofThumbnail: 'Miniature de la preuve',
    zoomIn: 'Zoom avant',
    zoomOut: 'Zoom arrière',
    openInNewTab: 'Ouvrir dans un nouvel onglet',
    bank: 'Banque',
    crypto: 'Crypto',
    card: 'Carte',
    bankPerCountry: 'Banque (par pays)',
    bankPerUser: 'Banque (par utilisateur)',
    bankTransfer: 'Virement bancaire',
    bankTransferPerCountry: 'Virement (par pays)',
    bankTransferPerUser: 'Virement (par utilisateur)',
    averageDeposit: 'Dépôt moyen',
  },
  withdrawals: {
    title: 'Retraits',
    allWithdrawals: 'Tous les retraits',
    allStatuses: 'Tous les statuts',
    pending: 'En attente',
    approved: 'Approuvé',
    rejected: 'Rejeté',
    completed: 'Terminé',
    searchPlaceholder: 'Rechercher des retraits...',
    searchByIdNameEmail: 'Rechercher par ID, nom ou e-mail...',
    idNameOrEmail: 'ID, nom ou e-mail...',
    amount: 'Montant',
    method: 'Méthode',
    status: 'Statut',
    trader: 'Trader',
    date: 'Date',
    actions: 'Actions',
    approve: 'Approuver',
    reject: 'Rejeter',
    confirmApproval: 'Confirmer l\'approbation — les fonds seront envoyés au trader.',
    confirmWithdrawalApproval: 'Confirmer l\'approbation du retrait — les fonds seront libérés.',
    confirmRejection: 'Confirmer le rejet — entrez une raison (optionnel).',
    rejectionReason: 'Raison du rejet (optionnel)...',
    approveSuccess: 'Retrait approuvé avec succès',
    rejectSuccess: 'Retrait rejeté avec succès',
    failedToApprove: 'Échec de l\'approbation du retrait',
    failedToReject: 'Échec du rejet du retrait',
    noWithdrawalsFound: 'Aucun retrait trouvé',
    averageWithdrawal: 'Retrait moyen',
  },
  auditLog: {
    title: 'Journal d\'audit',
    allActions: 'Toutes les actions',
    allEvents: 'Tous les événements',
    allLevels: 'Tous les niveaux',
    searchPlaceholder: 'Rechercher dans le journal...',
    emailActionOrId: 'E-mail, action ou ID...',
    event: 'Événement',
    user: 'Utilisateur',
    action: 'Action',
    timestamp: 'Horodatage',
    details: 'Détails',
    level: 'Niveau',
    info: 'Info',
    warning: 'Avertissement',
    error: 'Erreur',
    critical: 'Critique',
    noLogsFound: 'Aucun journal d\'audit trouvé',
    administrativeAction: 'Une action administrative a été enregistrée.',
    filterAuditLog: 'Filtrer le journal',
    reset: 'Réinitialiser',
    eventType: 'Type d\'événement',
    apply: 'Appliquer',
    totalEvents: 'Total événements',
    depositEvents: 'Événements dépôts',
    withdrawalEvents: 'Événements retraits',
    noEventsMatch: 'Aucun événement ne correspond',
    noEntriesMatch: 'Aucune entrée ne correspond au filtre.',
    showAll: 'Afficher tout',
    events: 'événement',
    eventsPlural: 'événements',
    totalEventsRecorded: 'Total événements enregistrés',
    performedBy: 'Effectué par',
    amount: 'Montant',
    paymentMethod: 'Méthode de paiement',
    balanceChange: 'Modification du solde',
    statusChange: 'Changement de statut',
    rejectionReason: 'Raison du rejet',
    actionWithdrawalRequested: 'Retrait demandé',
    actionDepositSubmitted: 'Dépôt soumis',
    actionProofUploaded: 'Preuve téléchargée',
    actionDepositApproved: 'Dépôt approuvé',
    actionDepositRejected: 'Dépôt rejeté',
    actionWithdrawalApproved: 'Retrait approuvé',
    actionWithdrawalRejected: 'Retrait rejeté',
    actionFundsLocked: 'Fonds bloqués',
    actionFundsReturned: 'Fonds retournés',
    fundsLockedSummary: 'Fonds bloqués en attente de révision du retrait.',
    fundsReturnedSummary: 'Fonds bloqués retournés après rejet.',
    depositsTab: 'Dépôts',
    withdrawalsTab: 'Retraits',
  },
  plugins: {
    title: 'Plugins',
    backToPlugins: 'Retour aux plugins',
    searchPlaceholder: 'Rechercher des plugins...',
    countrySelectNoMatch: 'Aucune correspondance',
    configurePlugin: 'Configurer le plugin',
    pressEscToClose: 'Appuyez sur {key} pour fermer',
    loadingUsers: 'Chargement...',
    available: 'Disponible',
    active: 'Actif',
    activate: 'Activer',
    deactivate: 'Désactiver',
    configure: 'Configurer',
    documentation: 'Documentation',
    settings: 'Paramètres',
    noPluginsFound: 'Aucun plugin trouvé',
    pluginDetails: 'Détails du plugin',
    version: 'Version',
    author: 'Auteur',
    description: 'Description',
    filterInactive: 'Inactif',
    paymentGateways: 'Passerelles de paiement',
    stripeTitle: 'Stripe',
    stripeDescription: 'Accepter les paiements via Stripe',
    paypalTitle: 'PayPal',
    paypalDescription: 'Accepter les paiements via PayPal',
    communicationTools: 'Outils de communication',
    twilioTitle: 'Twilio SMS',
    twilioDescription: 'Envoyer des notifications SMS',
    mailgunTitle: 'Mailgun',
    mailgunDescription: 'Service de livraison d\'e-mails',
    bankFieldAccountHolder: 'Titulaire du compte',
    bankFieldBankName: 'Nom de la banque',
    bankFieldAccountNumber: 'Numéro de compte',
    bankFieldRoutingNumber: 'Numéro de routage (optionnel)',
    bankFieldSetAsDefault: 'Définir par défaut',
    copyTradingTitle: 'Copy Trading',
    copyTradingDescription: 'Activer les fonctionnalités de copy trading',
    tradingTools: 'Outils de trading',
    mam: 'MAM/PAMM',
    apiKey: 'Clé API',
    apiSecret: 'Secret API',
    accountSid: 'SID de compte',
    authToken: 'Token d\'authentification',
    authDomain: 'Domaine d\'authentification',
    appId: 'ID d\'application',
    loadingPlugins: 'Chargement des plugins...',
    noPluginsMatch: 'Aucun plugin ne correspond',
    tryDifferentSearch: 'Essayez une recherche différente',
    tryAdjustingSearch: 'Essayez d\'ajuster votre recherche',
    activeCount: '{count} actif · {owned} possédé · {available} en boutique',
    ofPurchasedActive: 'sur {count} achetés actifs',
    expired: 'Expiré',
    expires: 'Expire',
    free: 'Gratuit',
    buyPlugin: 'Acheter — ${price}{cycle}',
    openInFullPage: 'Ouvrir en pleine page',
    noConfigPanel: 'Aucun panneau de configuration disponible.',
    currentStatus: 'Statut actuel',
    failedToUpdateKyc: 'Échec de la mise à jour KYC',
    filterAll: 'Tous',
    filterActive: 'Actif',
    filterOwned: 'Possédé',
    filterStore: 'Boutique',
    pluginNotFound: 'Plugin introuvable',
    loadingPlugin: 'Chargement du plugin...',
    failedToLoadPlugin: 'Échec du chargement du plugin',
    noConfigAvailable: 'Aucun panneau de configuration disponible.',
    activeStatus: 'Actif',
    editLabel: 'Modifier',
    newLabel: 'Nouveau',
    addLabel: 'Ajouter',
    saveLabel: 'Enregistrer',
    cancelLabel: 'Annuler',
    globalBankAccount: 'Compte bancaire global',
    addBankAccount: 'Ajouter un compte bancaire',
    defaultLabel: '(défaut)',
    cryptoWallet: 'Portefeuille crypto',
    addCryptoWallet: 'Ajouter un portefeuille crypto',
    coinPlaceholder: 'Devise (ex. BTC)',
    networkPlaceholder: 'Réseau (ex. mainnet)',
    walletAddressPlaceholder: 'Adresse du portefeuille',
    labelOptionalPlaceholder: 'Libellé (optionnel)',
    paymentLink: 'Lien de paiement',
    addPaymentLink: 'Ajouter un lien de paiement',
    linkNamePlaceholder: 'Nom (ex. Stripe Checkout)',
    perUserBankAccount: 'Compte bancaire par utilisateur',
    addUserBankMapping: 'Ajouter un mapping utilisateur → banque',
    editExistingAccount: 'Modifier le compte existant',
    assignedUsers: 'Utilisateurs assignés',
    pickTraders: 'Choisir des traders',
    searchAddTrader: 'Rechercher et ajouter un trader...',
    perCountryBankAccount: 'Compte bancaire par pays',
    addCountryBankMapping: 'Ajouter un mapping pays → banque',
    mappedCountries: 'Pays mappés',
    pickCountries: 'Choisir des pays',
    searchAddCountries: 'Rechercher et ajouter des pays...',
    badgeActive: 'Actif',
    badgeInactive: 'Inactif',
    badgeExpired: 'Expiré',
    purchasePlugin: 'Acheter le plugin',
    paymentMethod: 'Méthode de paiement',
    generatePaymentAddress: 'Générer l\'adresse de paiement',
    sendExactly: 'Envoyer exactement',
    toAddressBelow: 'à l\'adresse ci-dessous',
    paymentAddress: 'Adresse de paiement',
    waitingForPayment: 'En attente de paiement...',
    paymentDetected: 'Paiement détecté ! Confirmation...',
    confirmationsReceived: '{count} confirmation reçue',
    confirmationsReceivedPlural: '{count} confirmations reçues',
    expiresIn: 'Expire dans :',
    paymentId: 'ID de paiement :',
    paymentConfirmed: 'Paiement confirmé !',
    pluginActivated: '{name} a été activé.',
    networkError: 'Erreur réseau. Veuillez réessayer.',
    failedToCreatePayment: 'Échec de la création du paiement',
    paymentExpired: 'Fenêtre de paiement expirée. Créez un nouveau paiement.',
  },
  apiDocs: {
    title: 'Documentation API',
    authentication: 'Authentification',
    baseUrl: 'URL de base :',
    allRequestsRequire: 'Toutes les requêtes nécessitent deux en-têtes :',
    apiKeyManagement: 'Gestion des clés API avec contrôles de portée',
    billing: 'Facturation',
    apiAccess: 'Accès API',
    apiAccessAddon: 'Extension d\'accès API active',
    buyAddon: 'Acheter l\'extension — 199 $/mois',
    getAccounts: 'GET /accounts',
    getAccountDetails: 'GET /accounts/:id',
    updateAccount: 'PATCH /accounts/:id',
    getDeposits: 'GET /deposits',
    approveDeposit: 'POST /deposits/:id/approve',
    rejectDeposit: 'POST /deposits/:id/reject',
    getWithdrawals: 'GET /withdrawals',
    approveWithdrawal: 'POST /withdrawals/:id/approve',
    rejectWithdrawal: 'POST /withdrawals/:id/reject',
    approvalsDescription: 'Approuver les dépôts et retraits par programmation',
    approveDepositDesc: 'Approuver un dépôt (statut doit être proof_uploaded).',
    approveWithdrawalDesc: 'Approuver un retrait en attente.',
    restApi: 'REST API',
    baseUrlLabel: 'URL de base :',
    yourApiKeys: 'Vos clés API',
    noApiKeysYet: 'Aucune clé API',
    generateNewKey: 'Générer une nouvelle clé',
    revokeKey: 'Révoquer',
    rateLimit: 'Limite de débit',
    maxKeys: 'Clés maximum',
    reqPerMin: '{limit} req/min',
    exampleRequest: 'Exemple de requête',
    queryParameters: 'Paramètres de requête',
    endpoints: 'endpoint',
    endpointsPlural: 'endpoints',
    includedInPlan: 'Inclus dans votre plan Enterprise',
    addonActive: 'Extension d\'accès API active',
    restApiAccess: 'Accès REST API',
    restApiDesc: 'L\'accès REST API est disponible avec le plan Enterprise ou comme extension.',
    featureReadClients: 'Lire clients, comptes et historique de trading',
    featureApprovePayments: 'Approuver les dépôts et retraits par programmation',
    featureApiKeyManagement: 'Gestion des clés API avec contrôles de portée',
    featureRateLimit: 'Jusqu\'à 60 requêtes par minute par clé',
    featureInteractiveDocs: 'Documentation interactive dans votre tableau de bord',
    upgradeToEnterprise: 'Passer à Enterprise',
    buyAddonPrice: 'Acheter l\'extension — 199 $/mois',
    generateApiKey: 'Générer une clé API',
    keyName: 'Nom de la clé',
    keyNamePlaceholder: 'ex. Clé de production',
    scopes: 'Portées',
    generating: 'Génération...',
    generateKey: 'Générer la clé',
    keyGenerated: 'Clé générée',
    copySecretWarning: '⚠️ Copiez votre secret maintenant — il ne sera plus affiché.',
    apiKeyLabel: 'Clé API',
    apiSecretLabel: 'Secret API',
    done: 'Terminé',
    enterKeyName: 'Entrez un nom de clé',
    failedToCreateKey: 'Échec de la création de la clé',
    keyRevoked: 'Clé révoquée',
    confirmRevoke: 'Révoquer cette clé API ? Cette action est irréversible.',
  },
  notifications: {
    title: 'Paramètres de notifications',
    emailNotifications: 'Notifications e-mail',
    smsNotifications: 'Notifications SMS',
    pushNotifications: 'Notifications push',
    deposits: 'Dépôts',
    withdrawals: 'Retraits',
    newClients: 'Nouveaux clients',
    kycApplications: 'Demandes KYC',
    systemAlerts: 'Alertes système',
    enabled: 'Activé',
    disabled: 'Désactivé',
    saveSettings: 'Enregistrer',
    settingsSaved: 'Paramètres enregistrés',
    notificationChannels: 'Canaux de notification',
    configureChannels: 'Configurez comment la plateforme envoie des alertes aux clients.',
    saveAll: 'Tout enregistrer',
    saving: 'Enregistrement...',
    enableToConfigure: 'Activez pour configurer {title}',
    emailSmtp: 'E-mail (SMTP)',
    emailSmtpSubtitle: 'Envoyer des e-mails via votre propre serveur SMTP',
    recommended: 'Recommandé',
    smtpHost: 'Hôte SMTP',
    smtpPort: 'Port SMTP',
    usernameEmail: 'Nom d\'utilisateur / E-mail',
    passwordAppPassword: 'Mot de passe / Mot de passe d\'application',
    fromEmail: 'E-mail expéditeur',
    fromName: 'Nom expéditeur',
    useTls: 'Utiliser TLS / STARTTLS',
    useTlsHint: 'Recommandé pour le port 587.',
    sendTestEmail: 'Envoyer un e-mail de test',
    pushFcm: 'Notifications push (FCM)',
    pushFcmSubtitle: 'Firebase Cloud Messaging pour Android, iOS et Web',
    pushSetupRequired: 'Configuration requise',
    pushSetupDesc: 'Allez dans Firebase Console → Paramètres du projet → Comptes de service.',
    serviceAccountCredentials: 'Identifiants du compte de service',
    clientTokenStatus: 'Statut du token client',
    clientTokenDesc: 'Les tokens push sont enregistrés automatiquement lors de la connexion.',
    testPush: 'Tester Push',
    webAppConfig: 'Configuration de l\'application web',
    webAppConfigured: 'Configuré — {project}',
    webAppRequired: 'Requis pour les notifications navigateur et mobile',
    webAppWhereToFind: 'Où trouver ces informations',
    webAppWhereToFindDesc: 'Firebase Console → Paramètres du projet → Vos applications',
    saveWebConfig: 'Enregistrer la config web',
    vapidKey: 'Clé VAPID',
    vapidKeyHint: '— Onglet Cloud Messaging → Certificats Web Push',
    credentialsOnFile: 'Identifiants enregistrés',
    credentialsStoredSecurely: 'Stockés en sécurité sur le serveur',
    replaceCredentials: 'Remplacer',
    uploadServiceAccount: 'Télécharger le JSON du compte de service',
    uploadServiceAccountHint: 'Cliquez pour sélectionner — validé et stocké en sécurité',
    uploadingValidating: 'Téléchargement et validation...',
    uploadSuccess: 'Identifiants Firebase téléchargés avec succès',
    uploadFailed: 'Échec — vérifiez que le fichier est un JSON Firebase valide',
    saveWebConfigSuccess: 'Configuration web Firebase enregistrée',
    saveWebConfigFailed: 'Échec de l\'enregistrement de la config web',
    smsTwilio: 'SMS (Twilio)',
    smsTwilioSubtitle: 'Envoyer des SMS via Twilio',
    smsSetupRequired: 'Configuration requise',
    smsSetupDesc: 'Obtenez vos identifiants sur console.twilio.com',
    accountSid: 'SID de compte',
    accountSidHint: 'Commence par AC...',
    authToken: 'Token d\'authentification',
    fromPhoneNumber: 'Numéro expéditeur',
    fromPhoneHint: 'Format E.164, ex. +33123456789',
    sendTestSms: 'Envoyer un SMS de test',
    statusConnected: 'Connecté',
    statusError: 'Erreur',
    statusUntested: 'Non testé',
    statusTesting: 'Test en cours...',
    notificationRouting: 'Routage des notifications',
    notificationRoutingDesc: 'Choisissez les canaux pour chaque type de notification',
    noChannelsEnabled: 'Aucun canal activé',
    noChannelsEnabledDesc: 'Activez au moins un canal pour configurer le routage',
    notifMarginCall: 'Appel de marge',
    notifMarginCallDesc: 'Quand le niveau de marge tombe sous le seuil',
    notifLiquidation: 'Liquidation',
    notifLiquidationDesc: 'Quand des positions sont fermées de force',
    notifDeposit: 'Dépôt',
    notifDepositDesc: 'Quand un dépôt est confirmé',
    notifWithdrawal: 'Retrait',
    notifWithdrawalDesc: 'Quand un retrait est traité',
    notifTradeOpened: 'Trade ouvert',
    notifTradeOpenedDesc: 'Quand une nouvelle position est ouverte',
    notifTradeClosed: 'Trade fermé',
    notifTradeClosedDesc: 'Quand une position est fermée',
    failedToLoad: 'Échec du chargement des paramètres',
    failedToSave: 'Échec de l\'enregistrement',
    testSuccess: 'Test {channel} réussi — vérifiez votre boîte de réception',
    testFailed: 'Test {channel} échoué',
  },
  upgrade: {
    title: 'Mettre à niveau le plan',
    currentPlan: 'Plan actuel',
    choosePlan: 'Choisir un plan',
    basic: 'Basique',
    professional: 'Professionnel',
    enterprise: 'Entreprise',
    perMonth: '/mois',
    perYear: '/an',
    monthly: 'Mensuel',
    annually: 'Annuel',
    features: 'Fonctionnalités',
    selectPlan: 'Sélectionner le plan',
    currentPlanLabel: 'Plan actuel',
    upgradeTo: 'Passer à',
    contactSales: 'Contacter les ventes',
    unlimitedClients: 'Clients illimités',
    unlimitedAccounts: 'Comptes illimités',
    advancedReporting: 'Rapports avancés',
    prioritySupport: 'Support prioritaire',
    apiAccess: 'Accès API',
    customBranding: 'Image de marque personnalisée',
    whiteLabel: 'Marque blanche',
    dedicatedManager: 'Gestionnaire de compte dédié',
    upgradeAvailable: 'Mise à niveau disponible',
    plan: 'Plan',
    unlock: 'Débloquer',
    apiAccessFeature: ', accès API',
    andMore: '& plus',
    renew: 'Renouveler',
  },
  theme: {
    light: 'Mode clair',
    dark: 'Mode sombre',
    toggle: 'Basculer le thème',
  },
  language: {
    english: 'English',
    arabic: 'العربية',
    turkish: 'Türkçe',
    select: 'Sélectionner la langue',
  },
  errors: {
    general: 'Une erreur s\'est produite',
    networkError: 'Erreur réseau. Vérifiez votre connexion.',
    unauthorized: 'Non autorisé. Veuillez vous reconnecter.',
    forbidden: 'Accès refusé.',
    notFound: 'Ressource introuvable.',
    serverError: 'Erreur serveur. Veuillez réessayer.',
    actionFailed: 'Action échouée',
  },
  success: {
    saved: 'Enregistré avec succès',
    updated: 'Mis à jour avec succès',
    deleted: 'Supprimé avec succès',
    created: 'Créé avec succès',
    copied: 'Copié dans le presse-papiers',
  },
  time: {
    seconds: 'secondes',
    minutes: 'minutes',
    hours: 'heures',
    days: 'jours',
    weeks: 'semaines',
    months: 'mois',
    years: 'ans',
    ago: 'il y a',
    justNow: 'à l\'instant',
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    tomorrow: 'Demain',
  },
  units: {
    usd: 'USD',
    eur: 'EUR',
    gbp: 'GBP',
    lot: 'lot',
    lots: 'lots',
    pips: 'pips',
    percent: '%',
  },
  cascade: {
    settingsArchitecture: 'Architecture des paramètres',
    title: 'Système de priorité en cascade',
    subtitle: 'Les paramètres se résolvent de la priorité la plus haute à la plus basse. Laissez un champ',
    subtitleNull: 'vide (NULL)',
    subtitleFallthrough: 'pour passer à la couche suivante.',
    resolutionOrder: 'Ordre de résolution :',
    firstNonNull: 'La première valeur non nulle l\'emporte',
    highestPriority: 'Priorité la plus haute — Cliquez sur une couche pour explorer',
    ifEmptyFallsThrough: '↓ si vide, passe à la suivante',
    priority: 'Priorité',
    leaveFieldEmpty: 'Laissez un champ vide (NULL)',
    skipLayer: 'pour passer cette couche et aller à',
    finalFallback: 'Dernier recours — aucune couche en dessous.',
    hardLimitsNote: 'Les champs marqués',
    hardLimitsNote2: 'sont des limites strictes appliquées à l\'échelle du système.',
    layers: {
      userOverride: 'Remplacement utilisateur',
      userSublabel: 'Accords spéciaux par client',
      userTooltip: 'Priorité la plus haute. Tout champ défini ici l\'emporte sur tout le reste.',
      userFallsTo: 'Groupe de comptes (P2)',
      accountGroup: 'Groupe de comptes',
      groupSublabel: 'Niveaux VIP, Standard, Professionnel',
      groupTooltip: 'Appliqué à tous les clients de ce groupe.',
      groupFallsTo: 'Paramètres du symbole (P3)',
      symbolSettings: 'Paramètres du symbole',
      symbolSublabel: 'Config courtier par instrument',
      symbolTooltip: 'Contrôle les règles de tarification et d\'exécution par instrument.',
      symbolFallsTo: 'Valeurs par défaut (P4)',
      platformDefaults: 'Valeurs par défaut',
      platformSublabel: 'Recours système et limites strictes',
      platformTooltip: 'Priorité la plus basse, mais applique des limites absolues.',
    },
    setByBroker: 'Défini par le courtier',
    setBySystemAdmin: 'Défini par l\'administrateur',
    goToClients: 'Aller aux clients',
    goToAccountGroups: 'Aller aux groupes',
    goToInstruments: 'Aller aux instruments',
    fields: {
      maxLeverage: 'Levier maximum',
      maxLotSize: 'Taille de lot maximale',
      marginCallLevel: 'Niveau d\'appel de marge',
      stopOutLevel: 'Niveau de stop out',
      maxOpenPositions: 'Positions ouvertes max',
      commissionPerLot: 'Commission par lot',
      tradingDisabled: 'Trading désactivé',
      spreadMarkup: 'Majoration du spread',
      swapMarkup: 'Majoration du swap',
      tripleSwapDay: 'Jour de triple swap',
      stopLevel: 'Niveau de stop',
      freezeLevel: 'Niveau de gel',
      defaultLeverage: 'Levier par défaut',
      defaultCommission: 'Commission par défaut',
      defaultMarginCall: 'Appel de marge par défaut',
      defaultStopOut: 'Stop out par défaut',
      maxLeverageCap: 'Plafond de levier max',
      minMarginCall: 'Appel de marge minimum',
      minStopOut: 'Stop out minimum',
      maxCommissionCap: 'Plafond de commission',
      maxPositionsCap: 'Plafond de positions',
    },
    fieldDescs: {
      capLeverageClient: 'Plafonner le levier pour ce client',
      limitPositionSize: 'Limiter la taille de position par trade',
      overrideAlertThreshold: 'Remplacer le seuil d\'alerte',
      overrideAutoClose: 'Remplacer le seuil de fermeture automatique',
      limitConcurrentTrades: 'Limiter les trades simultanés',
      customCommission: 'Taux de commission personnalisé',
      killSwitch: 'Interrupteur d\'urgence pour ce client',
      groupCommission: 'Taux de commission du groupe',
      groupLeverage: 'Plafond de levier du groupe',
      groupMarginCall: 'Seuil d\'alerte du groupe',
      groupStopOut: 'Seuil de fermeture auto du groupe',
      groupPositions: 'Limite de positions du groupe',
      groupLotSize: 'Limite de taille de trade du groupe',
      pipsAddedSpread: 'Pips ajoutés au spread brut',
      symbolCommission: 'Commission spécifique au symbole',
      overnightSwap: 'Ajouté aux taux de swap overnight',
      tripleSwapDay: 'Jour où le triple swap est facturé',
      symbolLeverage: 'Plafond de levier du symbole',
      symbolLotSize: 'Limite de taille de trade du symbole',
      minSlTpDistance: 'Distance SL/TP minimale en pips',
      modificationFreeze: 'Distance de gel de modification',
      fallbackLeverage: 'Levier de secours',
      fallbackCommission: 'Commission de secours',
      fallbackMarginCall: 'Appel de marge de secours',
      fallbackStopOut: 'Stop out de secours',
      hardCeilingLeverage: 'Plafond strict — aucune couche ne peut dépasser',
      hardFloorMarginCall: 'Plancher strict — aucune couche ne peut descendre',
      hardFloorStopOut: 'Plancher strict — aucune couche ne peut descendre',
      hardCeilingCommission: 'Plafond strict de commission',
      systemPositionLimit: 'Limite de positions système',
    },
  },
  emailTemplates: {
    loadingTemplates: 'Chargement des modèles...',
    loadingTemplate: 'Chargement du modèle...',
    retry: 'Réessayer',
    allTemplates: '← Tous les modèles',
    customised: 'Personnalisé',
    custom: 'Personnalisé',
    default: 'Par défaut',
    subjectLine: 'Ligne d\'objet',
    subjectPlaceholder: 'Objet de l\'e-mail...',
    editorTab: 'Éditeur',
    htmlTab: 'HTML',
    previewTab: 'Aperçu',
    variables: 'Variables :',
    showLess: 'Afficher moins',
    clickToInsert: 'Cliquez pour insérer une variable :',
    saveTemplate: 'Enregistrer le modèle',
    savingTemplate: 'Enregistrement...',
    resetToDefault: 'Réinitialiser par défaut',
    resetting: 'Réinitialisation...',
    back: 'Retour',
    resetConfirm: 'Réinitialiser au modèle premium par défaut ? Vos personnalisations seront perdues.',
    subjectBodyRequired: 'L\'objet et le corps sont obligatoires',
    activeBranding: 'Image de marque active',
    companyName: 'Nom de la société',
    primaryColor: 'Couleur principale',
    logoUrl: 'URL du logo',
    noLogoSet: 'Aucun logo défini',
    emailFooter: 'Pied de page',
    brandingNote: 'Pour mettre à jour votre image de marque, allez dans Paramètres du courtier.',
    editBranding: 'Modifier l\'image de marque',
    closeBranding: 'Fermer l\'image de marque',
    templateListDesc: 'Cliquez sur un modèle pour le modifier.',
    templateInfoNote: 'Les modèles marqués Défaut utilisent le design intégré avec votre image de marque.',
    loadingBranding: 'Chargement de l\'image de marque...',
    typeDepositApproved: 'Dépôt approuvé',
    typeDepositRejected: 'Dépôt rejeté',
    typeWithdrawalApproved: 'Retrait approuvé',
    typeWithdrawalRejected: 'Retrait rejeté',
    typeMarginCall: 'Appel de marge',
    typeLiquidation: 'Compte liquidé',
    typeKycApproved: 'KYC approuvé',
    typeKycRejected: 'KYC rejeté',
    typeWelcome: 'E-mail de bienvenue',
  },
  credits: {
    activeRules: 'Règles actives',
    totalAwarded: 'Total attribué',
    awardEvents: 'Événements d\'attribution',
    bonusRules: 'Règles de bonus',
    awardHistory: 'Historique d\'attribution',
    newRule: 'Nouvelle règle',
    manualAward: 'Attribution manuelle',
    noBonusRules: 'Aucune règle de bonus. Ajoutez-en une pour commencer.',
    noCreditAwards: 'Aucune attribution de crédit.',
    deactivateConfirm: 'Désactiver cette règle ?',
    revokeReason: 'Raison de révocation (optionnel) :',
    operationFailed: 'Opération échouée',
    bonusRuleTitle: 'Règle de bonus {mode}',
    ruleName: 'Nom de la règle (ex. Bonus de bienvenue)',
    percentOfDeposit: '% du dépôt (ex. 20)',
    fixedAmountUsd: 'Montant fixe (USD)',
    maxCreditCap: 'Plafond de crédit max (optionnel)',
    minDepositQualify: 'Dépôt minimum pour qualifier',
    expiresAfterDays: 'Expire après N jours (optionnel)',
    ruleActive: 'Actif — attribution automatique sur dépôts qualifiés',
    ruleDisabled: 'Désactivé',
    savingDots: 'Enregistrement...',
    awardingDots: 'Attribution...',
    manualCreditAward: 'Attribution manuelle de crédit',
    accountId: 'ID de compte',
    userId: 'ID utilisateur',
    amountUsd: 'Montant (USD)',
    notesOptional: 'Notes (optionnel)',
    awardCredit: 'Attribuer du crédit',
    infoWelcomeDeposit: 'Les règles WELCOME et DEPOSIT se déclenchent automatiquement à l\'approbation du dépôt.',
    bonusWelcome: 'Bienvenue',
    bonusDeposit: 'Dépôt',
    bonusGoodwill: 'Bonne volonté',
    bonusPromotion: 'Promotion',
    statusRevoked: 'Révoqué',
    statusExpired: 'Expiré',
  },
  pages: {
    websitePages: 'Pages du site',
    websitePagesDesc: 'Créez et gérez votre site web.',
    pluginNotActive: 'Plugin non actif.',
    viewPlugins: 'Voir les plugins',
    mainPages: 'Pages principales',
    legalPages: 'Pages légales',
    langs: 'langues',
    save: 'Enregistrer',
    saved: 'Enregistré',
    error: 'Erreur',
    publish: 'Publier',
    unpublish: 'Dépublier',
    published: 'Publié',
    draft: 'Brouillon',
    tabBlocks: 'Blocs',
    tabSeo: 'SEO',
    addBlock: 'Ajouter un bloc',
    addFirstBlock: 'Ajouter le premier bloc',
    addFirstBlockHint: 'Ajoutez votre premier bloc de contenu',
    noBlocks: 'Aucun bloc',
    pageTitle: 'Titre de la page',
    pageTitleHint: 'Titre principal affiché dans la navigation',
    translatable: 'Traduisible',
    pageSlug: 'Slug de la page',
    seoTitle: 'Titre SEO',
    seoDescription: 'Description SEO',
    googlePreview: 'APERÇU GOOGLE',
    noDescription: 'Aucune description.',
    catHeroLayout: 'Hero et mise en page',
    catContent: 'Contenu',
    catFeaturesData: 'Fonctionnalités et données',
    catSocialProof: 'Preuve sociale',
    catCta: 'Appel à l\'action',
    catDocuments: 'Documents et légal',
    catOther: 'Autre',
    missing: 'Manquant',
    add: 'Ajouter',
    addItem: 'Ajouter un élément',
    item: 'Élément',
    notStarted: 'Non commencé',
  },
  userOverride: {
    title: 'Remplacement du compte utilisateur',
    infoBannerTitle: 'Remplacements au niveau utilisateur (Couche 1)',
    infoBannerDesc: 'Ces paramètres remplacent les valeurs par défaut du groupe. Laissez vide (NULL) pour utiliser les paramètres du groupe.',
    sectionTradingControl: 'Contrôle du trading',
    sectionRiskParameters: 'Paramètres de risque',
    sectionPricingOverrides: 'Remplacements de tarification',
    disableTrading: 'Désactiver le trading',
    disableTradingSubLabel: 'Empêcher cet utilisateur d\'ouvrir de nouvelles positions',
    resetToGroupDefault: 'Réinitialiser au défaut du groupe',
    groupDefault: 'Défaut du groupe',
    maxLeverage: 'Levier maximum',
    maxLotSize: 'Taille de lot maximale',
    minLotSize: 'Taille de lot minimale',
    marginCallLevel: 'Niveau d\'appel de marge (%)',
    stopOutLevel: 'Niveau de stop out (%)',
    maxOpenPositions: 'Positions ouvertes max',
    commissionPerLot: 'Commission par lot (USD)',
    commissionPerLotHint: 'USD facturé par lot standard tradé',
    minAboveMaxError: '⚠️ La taille min ne peut pas dépasser la taille max',
    currentOverrideTitle: 'Remplacement actif',
    currentOverrideDesc: 'Cet utilisateur a des paramètres personnalisés qui remplacent les valeurs par défaut du groupe.',
    saveOverride: 'Enregistrer le remplacement',
    saving: 'Enregistrement...',
    saveSuccess: 'Remplacement enregistré avec succès',
    saveFailed: 'Échec de l\'enregistrement',
    lots: 'lots',
    lotStep: 'Pas de lot',
  },
  symbolSettings: {
    sectionPricing: 'Tarification courtier',
    sectionRisk: 'Limites de risque',
    sectionExecution: 'Règles d\'exécution',
    sectionOverrides: 'Remplacements d\'instrument',
    sectionsLabel: 'Sections',
    pricingDesc: 'Ajustements appliqués sur les taux bruts de l\'instrument.',
    riskDesc: 'Limites de position et de levier au niveau du courtier.',
    executionDesc: 'Contraintes de placement et de modification des ordres.',
    overridesDesc: 'Activez chaque champ pour un remplacement au niveau du courtier.',
    overridesInfoTitle: 'Swap Long / Swap Short',
    overridesInfoDesc: 'Remplace entièrement le taux de l\'instrument lorsqu\'activé.',
    settingsTitle: 'Paramètres {symbol}',
    headerSubtitle: 'Configurer la tarification et le risque au niveau du courtier (Couche 3)',
    overrideActive: '{count} remplacement actif',
    overridesActive: '{count} remplacements actifs',
    spreadMarkup: 'Majoration du spread',
    spreadMarkupHint: 'Pips ajoutés au spread brut',
    commissionPerLot: 'Commission par lot',
    commissionPerLotHint: 'USD facturé par lot standard tradé',
    swapMarkup: 'Majoration du swap',
    swapMarkupHint: 'Points ajoutés aux taux de swap.',
    tripleSwapDay: 'Jour de triple swap',
    tripleSwapDayHint: 'Jour où le triple swap est facturé',
    maxLeverage: 'Levier maximum',
    maxLeverageHint: 'Levier maximum autorisé pour ce symbole',
    maxLotSize: 'Taille de lot maximale',
    maxLotSizeHint: 'Taille de position maximale par trade',
    minLotSize: 'Taille de lot minimale',
    minLotSizeHint: 'Taille de position minimale par trade',
    minAboveMaxError: '⚠️ La taille min ne peut pas dépasser la taille max',
    stopLevel: 'Niveau de stop',
    stopLevelHint: 'Distance minimale SL/TP (pips)',
    freezeLevel: 'Niveau de gel',
    freezeLevelHint: 'Distance de gel des modifications (pips)',
    contractSize: 'Taille du contrat',
    contractSizeHint: 'Unités par lot.',
    priceScale: 'Échelle de prix',
    priceScaleHint: 'Décimales pour la cotation.',
    swapLong: 'Swap Long (taux direct)',
    swapLongHint: 'Taux overnight pour positions ACHAT.',
    swapShort: 'Swap Short (taux direct)',
    swapShortHint: 'Taux overnight pour positions VENTE.',
    swapMode: 'Mode swap',
    swapModeHint: 'Comment le taux de swap overnight est calculé',
    maxVolume: 'Volume max (lots)',
    maxVolumeHint: 'Taille maximale d\'un seul trade en lots.',
    volumeStep: 'Pas de volume (lots)',
    volumeStepHint: 'Incrément minimal de taille de trade.',
    defaultBadge: 'défaut',
    pips: 'pips',
    pts: 'pts',
    lots: 'lots',
    decimals: 'décimales',
    dayMon: 'Lun',
    dayTue: 'Mar',
    dayWed: 'Mer',
    dayThu: 'Jeu',
    dayFri: 'Ven',
    daySat: 'Sam',
    daySun: 'Dim',
    loadingSettings: 'Chargement des paramètres...',
    saveSettings: 'Enregistrer les paramètres',
    lotStep: 'Pas de lot',
  },
  accountGroupForm: {
    sectionsLabel: 'Sections',
    sectionBasic: 'Informations de base',
    sectionPricing: 'Remplacements de tarification',
    sectionRisk: 'Gestion des risques',
    editTitle: 'Modifier le groupe de comptes',
    createTitle: 'Créer un groupe de comptes',
    basicInfoTitle: 'Informations de base',
    groupNameLabel: 'Nom du groupe *',
    groupNamePlaceholder: 'Groupe Standard',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Description du groupe...',
    groupActive: 'Groupe actif',
    defaultGroup: 'Groupe par défaut',
    pricingTitle: 'Remplacements de tarification',
    pricingDesc: 'Laissez vide pour utiliser les valeurs par défaut du courtier.',
    commissionPerLot: 'Commission par lot (USD)',
    commissionPerLotHint: 'USD facturé par lot standard tradé',
    maxLeverage: 'Levier maximum',
    maxLeverageHint: 'Levier maximum disponible pour ce groupe',
    brokerDefault: 'Défaut courtier',
    resetToNoLimit: 'Réinitialiser sans limite',
    riskTitle: 'Gestion des risques',
    marginCallLevel: 'Niveau d\'appel de marge',
    marginCallHint: 'Alerte quand le niveau de marge atteint ce pourcentage',
    stopOutLevel: 'Niveau de stop out',
    stopOutHint: 'Fermeture automatique à ce niveau de marge',
    maxOpenPositions: 'Positions ouvertes max',
    maxOpenPositionsHint: 'Nombre maximum de positions par compte',
    maxLotSize: 'Taille de lot maximale',
    maxLotSizeHint: 'Taille de lot maximale par trade',
    minLotSize: 'Taille de lot minimale',
    minLotSizeHint: 'Taille de lot minimale pour ce groupe',
    noLimit: 'Sans limite',
    lots: 'lots',
    marginBelowStopError: '⚠️ L\'appel de marge doit être supérieur au stop out',
    minAboveMaxError: '⚠️ La taille min ne peut pas dépasser la taille max',
    updateGroup: 'Mettre à jour le groupe',
    createGroup: 'Créer le groupe',
    lotStep: 'Pas de lot',
  },
  cryptoCheckout: {
    paymentConfirmedTitle: 'Paiement confirmé !',
    makePayment: 'Effectuer le paiement',
    depositFunds: 'Déposer des fonds',
    purchaseItem: 'Acheter {name}',
    subscribeTo: 'S\'abonner à {name}',
    selectPaymentMethod: 'Sélectionner la méthode de paiement',
    payWith: 'Payer avec {currencies}',
    creatingPayment: 'Création du paiement...',
    continue: 'Continuer',
    sendExactly: 'Envoyer exactement',
    approxUsd: '≈ ${amount} USD',
    hideQrCode: 'Masquer le code QR',
    showQrCode: 'Afficher le code QR',
    scanWithWallet: 'Scanner avec votre portefeuille mobile',
    toThisAddress: 'À cette adresse {network}',
    expiresIn: 'Expire dans',
    waitingForPayment: 'En attente du paiement...',
    waitingDesc: 'Envoyez le montant exact. Nous le détecterons automatiquement.',
    verifiedOnChain: 'Vérifié on-chain par AmorPay.',
    pluginActivated: '{name} a été activé.',
    depositCredited: 'Votre dépôt a été crédité sur votre compte.',
    subscriptionActive: 'Votre abonnement est maintenant actif.',
    paymentConfirmed: 'Votre paiement a été confirmé.',
    done: 'Terminé',
    noItemSelected: 'Aucun article sélectionné',
    failedToLoadOptions: 'Échec du chargement des options de paiement',
  },
  subscriptionGate: {
    accountSuspended: 'Compte suspendu',
    subscriptionExpired: 'Abonnement expiré',
    suspendedDesc: 'Votre compte a été suspendu. Contactez le support.',
    expiredDesc: 'Votre abonnement {plan} a expiré. Renouvelez pour restaurer l\'accès.',
    renewSubscription: 'Renouveler l\'abonnement',
    signOut: 'Se déconnecter',
    needHelp: 'Besoin d\'aide ? Contactez',
    lastChance: '⚠️ Dernière chance ! Votre abonnement {plan} a expiré. L\'accès se termine aujourd\'hui.',
    gracePeriodDay: 'Votre abonnement {plan} a expiré. Il vous reste {days} jour.',
    gracePeriodDays: 'Votre abonnement {plan} a expiré. Il vous reste {days} jours.',
    renewNow: 'Renouveler maintenant',
  },
  upgradePage: {
    renewTitle: 'Renouveler l\'abonnement',
    upgradeTitle: 'Mettre à niveau votre plan',
    currentlyOn: 'Actuellement sur',
    graceDaysLeft: '{days} jour restant',
    graceDaysLeftPlural: '{days} jours restants',
    expired: 'Expiré',
    graceWarning: 'Votre abonnement a expiré. Il vous reste {days} jour pour renouveler.',
    graceWarningPlural: 'Votre abonnement a expiré. Il vous reste {days} jours pour renouveler.',
    expiredWarning: 'Votre abonnement a expiré. Renouvelez maintenant.',
    renewOrUpgrade: 'Renouvelez votre plan actuel ou passez à un niveau supérieur.',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    mostPopular: 'Le plus populaire',
    currentPlan: 'Plan actuel',
    perMonth: '/mois',
    saveYearly: 'Économisez 10% — facturé ${amount}/an',
    unlimitedTraders: 'Traders illimités',
    tradersCount: '{count} traders',
    unlimitedAdmins: 'Admins illimités',
    adminsCount: '{count} admins',
    unlimitedInstruments: 'Instruments illimités',
    instrumentsCount: '{count} instruments',
    feedUltra: 'Flux ultra faible latence',
    feedPriority: 'Flux prioritaire',
    feedStandard: 'Flux standard',
    fullApiAccess: 'Accès API complet',
    selected: 'Sélectionné',
    selectPlan: 'Sélectionner le plan',
    fullComparison: 'Comparaison complète',
    featureCol: 'Fonctionnalité',
    featureTraders: 'Traders',
    featureAdmins: 'Admins',
    featureInstruments: 'Instruments',
    featureFeedLatency: 'Latence du flux',
    featureApiAccess: 'Accès API',
    featureForex: 'Forex',
    featureCrypto: 'Crypto',
    featureCommodities: 'Matières premières',
    featureIndices: 'Indices',
    featureStocks: 'Actions',
    selectedPlan: 'Plan sélectionné :',
    selectToContinue: 'Sélectionnez un plan pour continuer',
    perYear: '/an',
    renewNow: 'Renouveler',
    upgradeNow: 'Mettre à niveau',
    failedToLoadPlans: 'Échec du chargement des plans',
    selectPlanFirst: 'Veuillez d\'abord sélectionner un plan',
    planActivated: 'Plan {name} activé ! 🎉',
  },

  sidebar: {
    sectionOverview: 'Aperçu',
    sectionManagement: 'Gestion',
    sectionTrading: 'Trading',
    sectionFinance: 'Finance',
    sectionPlugins: 'Plugins',
    sectionSystem: 'Système',
    accountGroups: 'Groupes de comptes',
    cascadeGuide: 'Guide en cascade',
    pluginStore: 'Boutique de plugins',
    kycVerification: 'Vérification KYC',
    kycDashboard: 'Tableau de bord KYC',
    kycConfig: 'Config KYC',
    pages: 'Pages',
    credits: 'Crédits',
    emailTemplates: 'Modèles d\'e-mail',
    restApi: 'REST API',
    advancedAnalytics: 'Analytique avancée',
    descClients: 'Utilisateurs · Paramètres · Remplacements',
    descGroups: 'Groupes · Paramètres · Remplacements',
    descInstruments: 'Courtier · Paramètres · Remplacements',
    descAccounts: 'Comptes et soldes',
    descCascade: 'Système de priorité expliqué',
    descAnalytics: 'Insights propulsés par l\'IA',
    badgeLive: 'En direct',
    badgeActive: 'Actif',
    badgeAddon: 'Extension',
    badgePro: 'PRO',
    badgeApi: 'API',
    badgeConfig: 'Config',
    badgeHowItWorks: 'Comment ça marche',
    cascadeTipFallthrough: 'Laissez les champs vides pour passer à la couche suivante',
  },

};